import { alwaysRefetchApiQueryOptions, REQUIRED_ONBOARDING_TASKS, resolveOnboardingCompletion } from 'BreetHelpers';
import {
	useGetDeveloperIntegrationQuery,
	useGetKybDetailsQuery,
	useGetTransactionsEditServicesQuery,
	useGetUserPreferenceQuery,
	useGetUserQuery,
} from 'BreetRedux';

export { REQUIRED_ONBOARDING_TASKS };

export const useOnboardingTodoListApi = () => {
	const { data: userPreferenceData, isFetching: userPreferenceFetching } = useGetUserPreferenceQuery(
		undefined,
		alwaysRefetchApiQueryOptions
	);
	const { data: userData, isFetching: userDataFetching } = useGetUserQuery(undefined, alwaysRefetchApiQueryOptions);

	const isKybCompleted = !!userData?.data?.approvedForLive;

	const { data: kybFormData, isFetching: kybFormFetching } = useGetKybDetailsQuery(undefined, {
		...alwaysRefetchApiQueryOptions,
		skip: isKybCompleted,
	});
	const { data: developerIntegrationData, isFetching: developerIntegrationFetching } = useGetDeveloperIntegrationQuery();
	const { isFetching: withdrawalHistoryFetching, data: withdrawalHistoryData } = useGetTransactionsEditServicesQuery(
		{ page: 1, size: 1, defaultParams: '' },
		alwaysRefetchApiQueryOptions
	);

	const isLoading =
		userPreferenceFetching || withdrawalHistoryFetching || kybFormFetching || developerIntegrationFetching || userDataFetching;

	const isMFAAuthentication =
		(userPreferenceData?.data?.usedRecoveryCodesCount ?? 0) + (userPreferenceData?.data?.unusedRecoveryCodesCount ?? 0) > 0 ||
		!!userPreferenceData?.data?.is2FAActive ||
		!!userPreferenceData?.data?.isAuthenticator2FaActive;

	const isFirstTransaction = !!withdrawalHistoryData?.data?.length;

	const kybStatus = kybFormData?.data?.status;

	const kybRejectionReason =
		kybStatus === 'rejected'
			? (kybFormData?.data?.reason ??
				'Your proof of address could not be verified. Please upload a utility bill or bank statement issued within the last 3 months and resubmit.')
			: undefined;

	const { isFirstProductionApiKey, isProductionWebhookUrl, requiredCompletedCount, isOnboardingComplete } =
		resolveOnboardingCompletion(userData?.data, developerIntegrationData?.data);

	const requiredProgressPercentage = Math.round((requiredCompletedCount / REQUIRED_ONBOARDING_TASKS) * 100);

	return {
		kybStatus,
		kybRejectionReason,
		isFirstProductionApiKey,
		isLoading,
		isMFAAuthentication,
		isFirstTransaction,
		isProductionWebhookUrl,
		requiredCompletedCount,
		requiredProgressPercentage,
		isOnboardingComplete,
		isKybCompleted,
	};
};
